window.console = window.console || {
  "log": function log() {}
}; //make sure any console statements don't break IE

module.exports = {
  storage: require("./storage.js"),
  svg: require("./svg.js"),
  version: {
    "yasgui-utils": require("../package.json").version
  },
  nestedExists: function nestedExists(obj) {
    var args = Array.prototype.slice.call(arguments, 1);

    for (var i = 0; i < args.length; i++) {
      if (!obj || !obj.hasOwnProperty(args[i])) {
        return false;
      }

      obj = obj[args[i]];
    }

    return true;
  }
};